import 'swiper/css'
import 'swiper/css/pagination'
import '@fontsource-variable/roboto'

import { useCallback, useEffect, useRef, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import Symbol from 'assets/ci/Symbol.png'
import Logo from 'assets/ci/로고.png'
import Logo_Kor from 'assets/ci/혼합형로고타입.png'
import { ReactComponent as Loader } from 'assets/icon/loading-spinner.svg'
import antiScamIcon from 'assets/icon/service/ico_antiscam_50.png'
import autocallIcon from 'assets/icon/service/ico_autocall_50.png'
import couponwalletIcon from 'assets/icon/service/ico_couponwallet_50.png'
import eventuIcon from 'assets/icon/service/ico_eventu_50.png'
import familycareIcon from 'assets/icon/service/ico_familycare_50.png'
import mfinderIcon from 'assets/icon/service/ico_mfinder_50.png'
import cert from 'assets/images/info/img_2022-t3_1327.png'
import mobileCert from 'assets/images/info/img_cert-mob.svg'
import certKoita from 'assets/images/info/img_certification_01.svg'
import mobileKoita from 'assets/images/info/img_certification_01-mob.svg'
import certInnobiz from 'assets/images/info/img_certification_02.svg'
import mobileInnobiz from 'assets/images/info/img_certification_02-mob.svg'
import certHc from 'assets/images/info/img_certification_03.svg'
import mobileHc from 'assets/images/info/img_certification_03-mob.svg'
import ci from 'assets/images/info/img_ci-color_450.png'
import symbol from 'assets/images/info/img_ci-logo_450.png'
import miniDu1 from 'assets/images/info/img_company_web01.png'
import mobileDu1 from 'assets/images/info/img_company_web01_764.png'
import du1 from 'assets/images/info/img_company_web01_1327.png'
import miniDu2 from 'assets/images/info/img_company_web02.png'
import mobileDu2 from 'assets/images/info/img_company_web02_764.png'
import du2 from 'assets/images/info/img_company_web02_1327.png'
import miniDu3 from 'assets/images/info/img_company_web03.png'
import mobileDu3 from 'assets/images/info/img_company_web03_764.png'
import du3 from 'assets/images/info/img_company_web03_1327.png'
import arrow from 'assets/json/du_arrow.json'
import serviceFront from 'assets/json/duservice-front.json'
import mobileServiceFront from 'assets/json/mobile-duservice-front.json'
import mobileBackground from 'assets/video/mobile-background-8sec.mp4'
import pcBackground from 'assets/video/PC-background-8sec.mp4'
import MapComponent from 'features/information/components/MapComponent'
import RollingPartner from 'features/information/components/RollingPartner'
import gsap from 'gsap'
import JSZip from 'jszip'
import Lottie from 'lottie-react'
import { getHistoryList, getPatentAndNewsList, getTotalNum } from 'shared/api/fetchs'
import MoreButton from 'shared/components/common/MoreButton'
import Pagination from 'shared/components/common/Pagination'
import PatentModal from 'shared/components/common/PatentModal'
import SeoHelmet from 'shared/components/common/SeoHelmet'
import TopButton from 'shared/components/common/TopButton'
import STYLE_GUIDE from 'shared/constants/color'
import { formatYmd } from 'shared/utils/format'
import styled from 'styled-components'
import { MainButton3 } from 'styles/common/button'
import { Mousewheel } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

const Information = () => {
  const PATENT_PAGE_SIZE = 10

  const { state } = useLocation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [patentsImg, setPatentsImg] = useState()
  const [patentList, setPatentList] = useState([])
  const [patentTotalNum, setPatentTotalNum] = useState()
  const [patentPageNum, setPatentPageNum] = useState(0)
  const [historyList, setHistoryList] = useState([])
  const [hasMoreHistory, setHasMoreHistory] = useState()
  const [isLoadingHistory, setLoadingHistory] = useState(false)
  const [historyPageNum, setHistoryPageNum] = useState(1)
  const [touchHeight, setTouchHeight] = useState(0)
  const [swiperIndex, setSwiperIndex] = useState(0)
  const sectionRef = useRef([])
  const [sloganFlag, setSloganFlag] = useState(true)
  const swiperRef = useRef()
  const [imgType, setImgType] = useState()

  const isPc = useMediaQuery({
    query: '(max-width:1919px)',
  })
  const isMobile = useMediaQuery({
    query: '(max-width:1199px)',
  })
  const isPhone = useMediaQuery({
    query: '(max-width:883px)',
  })

  useEffect(() => {
    setTimeout(() => {
      if (state?.state) {
        const section = document.querySelectorAll('.section')
        let sections = {}
        Array.prototype.forEach.call(section, function (e) {
          sections[e.id] = e.offsetTop - document.querySelector('.header')?.offsetHeight
        })
        if (state.state === 1) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
          swiperRef.current.swiper.enable()
          swiperRef.current.swiper.slideTo(0)
        } else {
          window.scrollTo({ top: sections['section' + state.state], behavior: 'smooth' })
        }
        state.state = null
        window.history.replaceState({}, document.title)
      }
    }, 400)
  }, [state?.state])

  const openModal = () => {
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
  }

  const enableSwiper = () => {
    document.getElementsByClassName('swiper-vertical')[0].style.touchAction = 'pan-x'
    swiperRef.current.swiper?.enable()
  }

  const disableSwiper = () => {
    document.getElementsByClassName('swiper-vertical')[0].style.touchAction = 'pan-y'
    swiperRef.current.swiper?.disable()
  }

  const elementRef = useRef(null)
  // const scrollHandler = (e) => {
  //   let st = window.scrollY || document.documentElement.scrollTop
  //   if (e.type === 'wheel') {
  //     if (st === 0 && !swiperRef.current.swiper?.enabled && e.deltaY < 0) {
  //       enableSwiper()
  //     }
  //     return
  //   }
  //   if (st !== 0 && swiperRef.current.swiper?.enabled) {
  //     disableSwiper()
  //   }
  //
  // }
  const scrollHandler = (e) => {
    let st = window.scrollY || document.documentElement.scrollTop
    const swiperEnabled = swiperRef.current.swiper?.enabled

    if (e.type === 'wheel') {
      if (st === 0 && !swiperEnabled && e.deltaY < 0) {
        disableSwiper()
      }
      // if (st === 0 && !swiperRef.current.swiper?.enabled && e.deltaY < 0) {
      //       enableSwiper()
      //     }
      //     return
    }
    // if (st === 0 && !swiperRef.current.swiper.enabled) {
    //     enableSwiper()
    //   }
    //   // } else {
    //   //   /*console.warn(`scrollHandler: st: ${st}, enabled: ${swiperRef.current.swiper.enabled}` )
    //   //   disableSwiper()*/
    //   // }

    if (st !== 0 && swiperEnabled) {
      disableSwiper()
    }
  }

  const getPatents = useCallback(async () => {
    const patentData = await getPatentAndNewsList('PATENTS', 0, patentPageNum, PATENT_PAGE_SIZE)
    setPatentList(patentData)

    const num = await getTotalNum('PATENTS_CNT')
    setPatentTotalNum(num.totalData)
  }, [patentPageNum, setPatentList, setPatentTotalNum])

  const getHistories = useCallback(async () => {
    if (hasMoreHistory) {
      const historyData = await getHistoryList('HISTORIES', historyPageNum)

      setHistoryList((h) => [
        ...h,
        ...historyData.filter((yearHistory) =>
          h.every((orgYearHistory) => orgYearHistory.Year !== yearHistory.Year),
        ),
      ])
    }
  }, [historyPageNum, hasMoreHistory, setHistoryList])

  const getHistoryCount = useCallback(async () => {
    const num = await getTotalNum('HISTORIES_CNT')
    setHasMoreHistory(num.TotalData > historyList.flatMap((obj) => obj.histories).length)
    setLoadingHistory(false)
  }, [historyList, setHasMoreHistory])

  const nextHistoryPage = () => {
    setLoadingHistory(true)
    setHistoryPageNum(historyPageNum + 1)
  }

  const ciDownload = () => {
    const image = [
      { img: Logo, name: 'Logo' },
      { img: Symbol, name: 'Symbol' },
      { img: Logo_Kor, name: 'Logo_Kor' },
    ]

    Promise.all(image.map((url) => fetch(url.img).then((response) => response.blob()))).then(
      async (blobs) => {
        const zip = new JSZip()

        blobs.forEach((d, i) => {
          zip.file(image[i].name + '.png', d)
        })

        zip.generateAsync({ type: 'blob' }).then(function (blob) {
          const url = URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'DataUniverse CI.zip')
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
        })
      },
    )
  }

  const serviceStyle = {
    width: isPc && !isMobile ? '920px' : '1400px',
  }

  function ani() {
    const fadeinEls = document.querySelectorAll('.caption')
    fadeinEls.forEach(function (textanimation, index) {
      gsap.fromTo(
        textanimation,
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, delay: index === 0 ? 0 : (index + 1) * 0.2 },
      )
    })
  }

  let startTouchY = 0
  let endTouchY = 0

  const touchStartHandler = (e) => {
    startTouchY = e.changedTouches[0].clientY
  }

  const touchEndHandler = (e) => {
    endTouchY = e.changedTouches[0].clientY
    setTouchHeight(Math.trunc(startTouchY) - Math.trunc(endTouchY))

    let vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }

  const popIconClick = () => {
    document.getElementById('section1').scrollIntoView({ behavior: 'smooth' })
  }

  useEffect(() => {
    window.addEventListener('scroll', scrollHandler)
    window.addEventListener('wheel', scrollHandler)
    window.addEventListener('touchstart', touchStartHandler)
    window.addEventListener('touchend', touchEndHandler)
    return () => {
      window.removeEventListener('scroll', scrollHandler)
      window.removeEventListener('wheel', scrollHandler)
      window.removeEventListener('touchstart', touchStartHandler)
      window.removeEventListener('touchend', touchEndHandler)
    }
  }, [])

  useEffect(() => {
    getPatents()
  }, [patentPageNum, getPatents])

  useEffect(() => {
    getHistories()
  }, [historyPageNum, getHistories])

  useEffect(() => {
    getHistoryCount()
  }, [historyList, getHistoryCount])

  useEffect(() => {
    if (touchHeight > 0 && swiperRef.current.swiper.enabled && swiperRef.current.swiper.isEnd) {
      disableSwiper()

      // window.scrollBy({
      //   top: touchHeight,
      //   left: 0,
      //   behavior: "smooth"
      // })
    } else {
      enableSwiper()
    }
  }, [touchHeight])

  const duLottieRef = useRef()
  useEffect(() => {
    switch (swiperIndex) {
      case 0:
        setTimeout(() => {
          duLottieRef.current.goToAndPlay(0, true)
        }, 1000)
        break
      case 1:
        if (sloganFlag) {
          ani()
          setSloganFlag(false)
        }
        break
      default:
    }
  }, [swiperIndex, isMobile])

  return (
    <>
      <SeoHelmet />
      <SwiperWrap>
        <Swiper
          ref={swiperRef}
          direction={'vertical'}
          slidesPerView={1}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 1,
            // releaseOnEdges: true,
          }}
          speed={1000}
          touchReleaseOnEdges={true}
          allowTouchMove={true}
          modules={[Mousewheel]}
          onSlideChange={(swiper) => {
            setTimeout(function () {
              setSwiperIndex(swiper.activeIndex)
            }, 1000)
          }}
          onReachEnd={(swiper) => {
            setTimeout(function () {
              disableSwiper()
            }, 1000)
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <BannerWrap>
              <div className="banner_wrap container">
                <div className="video_wrap">
                  {isMobile ? (
                    <>
                      <video
                        className="video"
                        src={mobileBackground}
                        autoPlay={true}
                        loop
                        muted
                        playsInline="playsinline"
                      />
                      <Lottie
                        lottieRef={duLottieRef}
                        loop={false}
                        autoplay={false}
                        animationData={mobileServiceFront}
                        className="lottie_service"
                      />
                    </>
                  ) : (
                    <>
                      <video
                        className="video"
                        src={pcBackground}
                        autoPlay={true}
                        loop
                        muted
                        playsInline="playsinline"
                      />
                      <Lottie
                        lottieRef={duLottieRef}
                        loop={false}
                        autoplay={false}
                        animationData={serviceFront}
                        className="lottie_service"
                        style={serviceStyle}
                      />
                    </>
                  )}
                </div>
              </div>
              <div className="arrow_area">
                {/*<p className="arrow_text">자세히 보기</p>*/}
                <Lottie animationData={arrow} className="lottie_arrow" onClick={popIconClick} />
              </div>
              <h1 className="visually-hidden">
                A better world is being created by DataUniverse, 개인을 보호하고 사람과 함께하며
                행복이 계속되는 세상
              </h1>
            </BannerWrap>
          </SwiperSlide>
          {/* <SwiperSlide>
            <SloganWrap ref={elementRef} className="section" id="section1">
              <video className="video" autoPlay={true} loop muted playsInline="playsinline">
                <source src={duVision} type="video/mp4" />
                <strong>Your browser does not support the video tag.</strong>
              </video>
              <div className="container">
                <div className="container video_cation_area">
                  <div className="caption video_cation1">
                    금융사기, 휴대폰 분실, 개인정보 유출, 가족 돌봄의 어려움,<br/>세대간 소통 부족 등 사회문제를 해결하기 위해
                  </div>
                  <div className="sub_caption">
                    <div className="caption video_cation2">
                      정보통신기술(ICT) 분야의 기술력과 서비스 경험을 바탕으로
                    </div>
                    <div className="caption video_cation3">
                      웹 3.0시대에 맞는 지능적이고 발전된 Global ICT 서비스를 만들어갑니다.
                    </div>
                  </div>
                </div>
              </div>
            </SloganWrap>
          </SwiperSlide> */}
        </Swiper>
      </SwiperWrap>
      <SectionWrap1 className="container version_section" id="section1">
        <div className="version_item">
          <div className="version_area">
            <h2 className="version">DU 1.0</h2>
          </div>
          <div className="version_content">
            <figure className="version_img">
              {isPhone && <img src={miniDu1} alt="" />}
              {!isPhone && isMobile && <img src={mobileDu1} alt="" />}
              {!isMobile && <img src={du1} alt="" />}
            </figure>
            <h3 className="version_title">기술로 사회문제를 해결합니다.</h3>
            <p className="version_detail">
              데이터유니버스는 ICT 기술을 활용해 금융사기, 개인정보 유출, 자산 보호 등의 개인에게
              발생할 수 있는 문제를 해결하고자 스마트피싱보호(Anti-Scam), 휴대폰분실보호(MFinder),
              오토콜(Autocall)을 출시하였습니다. 새롭게 발생하는 위협으로부터 개인을 보호하기 위해
              노력하고 있습니다.
            </p>
            <div className="icon_area">
              <div className="icon_wrap">
                <img src={antiScamIcon} alt="" />
                <span className="icon_title">Anti-Scam</span>
              </div>
              <div className="icon_wrap">
                <img src={mfinderIcon} alt="" />
                <span className="icon_title">MFinder</span>
              </div>
              <div className="icon_wrap">
                <img src={autocallIcon} alt="" />
                <span className="icon_title">AutoCall</span>
              </div>
            </div>
          </div>
        </div>
        <div className="version_item">
          <div className="version_area">
            <h2 className="version">DU 2.0</h2>
          </div>
          <div className="version_content">
            <figure className="version_img">
              {isPhone && <img src={miniDu2} alt="" />}
              {!isPhone && isMobile && <img src={mobileDu2} alt="" />}
              {!isMobile && <img src={du2} alt="" />}
            </figure>
            <h3 className="version_title">연결을 통한 상생과 소통에 함께합니다.</h3>
            <p className="version_detail">
              데이터유니버스는 사람을 연결하고 함께 성장할 수 있는 플랫폼을 제공하기 위해
              휴대폰가족보호, 이벤트U를 출시하였습니다. 기술이 주는 편리함으로 사람들에게 행복과
              혜택을 줄 수 있는 서비스를 지속적으로 만들어 가겠습니다.
            </p>
            <div className="icon_area">
              <div className="icon_wrap">
                <img src={familycareIcon} alt="" />
                <span className="icon_title">FamilyCare</span>
              </div>
              <div className="icon_wrap">
                <img src={eventuIcon} alt="" />
                <span className="icon_title">EventU</span>
              </div>
              <div className="icon_wrap">
                <img src={mfinderIcon} alt="" />
                <span className="icon_title">MFinder Global</span>
              </div>
              <div className="icon_wrap">
                <img src={couponwalletIcon} alt="" />
                <span className="icon_title">CouponWallet</span>
              </div>
            </div>
          </div>
        </div>
        <div className="version_item">
          <div className="version_area">
            <h2 className="version">DU 3.0</h2>
          </div>
          <div className="version_content">
            <figure className="version_img">
              {isPhone && <img src={miniDu3} alt="" />}
              {!isPhone && isMobile && <img src={mobileDu3} alt="" />}
              {!isMobile && <img src={du3} alt="" />}
            </figure>
            <h3 className="version_title">안전한 맞춤·지능형 서비스를 제공합니다.</h3>
            <p className="version_detail">
              데이터유니버스는 앞으로도 마이데이터 분석, AI를 활용한 에이징테크(AgeingTech),
              인슈어테크 등 다양한 분야에서 사람과 함께할 수 있는 맞춤형 서비스를 제공할 수 있도록
              나아가겠습니다.
            </p>
            <p className="unique">DATAUNIVERSE, Make a better Tomorrow</p>
          </div>
        </div>
      </SectionWrap1>
      <SectionWrap2
        ref={(el) => (sectionRef.current[1] = el)}
        id="section2"
        className="container patent_cert_section section"
      >
        <PatentModal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          imgType={imgType}
          patentsImg={patentsImg}
        />
        <h2 className="section_title">특허&인증</h2>
        <hr className="section_bar" />
        <div className="item_wrap">
          <h3 className="sub_title">특허 리스트</h3>
          <div className="top patent_list_wrap">
            <ul className="patent_list">
              {patentList.map((item) => (
                <li key={item.Idx}>
                  <span
                    className="patent_title"
                    onClick={() => {
                      setPatentsImg(item.ImagePath)
                      openModal()
                    }}
                  >
                    [특허 {item.PatentNum}] {item.PatentName}
                  </span>
                  <span className="patent_reg_dt">{formatYmd(item.PatentDate)}</span>
                </li>
              ))}
            </ul>
            {patentTotalNum > PATENT_PAGE_SIZE && (
              <Pagination
                className="pagination"
                patentTotalNum={patentTotalNum}
                setPatentPageNum={setPatentPageNum}
                divisionNum={PATENT_PAGE_SIZE}
              />
            )}
          </div>
        </div>
        <div className="item_wrap">
          <h3 className="sub_title">인증 내역</h3>
          {isMobile ? (
            <div className="patent_list_wrap">
              <figure className="main_img">
                <img src={mobileCert} alt="" />
              </figure>
              <div className="sub_img">
                <button
                  onClick={() => {
                    setImgType(0)
                    setPatentsImg(false)
                    openModal()
                  }}
                >
                  <figure className="">
                    <img src={mobileKoita} alt="" />
                  </figure>
                </button>
                <button
                  onClick={() => {
                    setImgType(1)
                    setPatentsImg(false)
                    openModal()
                  }}
                >
                  <figure className="">
                    <img src={mobileInnobiz} alt="" />
                  </figure>
                </button>
                <button
                  onClick={() => {
                    setImgType(2)
                    setPatentsImg(false)
                    openModal()
                  }}
                >
                  <figure className="">
                    <img src={mobileHc} alt="" />
                  </figure>
                </button>
              </div>
            </div>
          ) : (
            <div className="patent_list_wrap">
              <figure className="main_img">
                <img src={cert} alt="" />
              </figure>
              <div className="sub_img">
                <button
                  onClick={() => {
                    setImgType(0)
                    setPatentsImg(false)
                    openModal()
                  }}
                >
                  <figure className="">
                    <img src={certKoita} alt="" />
                  </figure>
                </button>
                <button
                  onClick={() => {
                    setImgType(1)
                    setPatentsImg(false)
                    openModal()
                  }}
                >
                  <figure className="">
                    <img src={certInnobiz} alt="" />
                  </figure>
                </button>

                <button
                  onClick={() => {
                    setImgType(2)
                    setPatentsImg(false)
                    openModal()
                  }}
                >
                  <figure className="">
                    <img src={certHc} alt="" />
                  </figure>
                </button>
              </div>
            </div>
          )}
        </div>
      </SectionWrap2>

      <SectionWrap3
        ref={(el) => (sectionRef.current[2] = el)}
        id="section3"
        className="container section"
      >
        <h2 className="section_title">히스토리</h2>
        <hr />
        {historyList.map((item) => (
          <div key={item.Year} className="history_item">
            <div className="history_area">
              <h3 className="year">{item.Year}</h3>
            </div>
            <div className="history_content w_history_content">
              <ul>
                {item.histories.map((history) => {
                  const arr = [
                    <li key={`h${history.Idx}`}>
                      <span className="month">{history.Month}</span>
                      <div className="history_detail">
                        {history.Content.split('\n').map((line, index) => (
                          <span key={index}>
                            {line}
                            <br />
                          </span>
                        ))}
                      </div>
                    </li>,
                  ]
                  if (history.ImageData) {
                    arr.push(
                      <li key={`himg_${history.Idx}`}>
                        {isMobile ? (
                          <img
                            src={history.MoImageData ?? history.ImageData}
                            alt=""
                            className={history.ImageType}
                          />
                        ) : (
                          <img src={history.ImageData} alt="" className={history.ImageType} />
                        )}
                      </li>,
                    )
                  }
                  return arr
                })}
              </ul>
            </div>
          </div>
        ))}
        {hasMoreHistory && !isLoadingHistory && (
          <div className="more-area">
            <MoreButton onClick={nextHistoryPage} disabled={isLoadingHistory} />
          </div>
        )}
        {isLoadingHistory && (
          <div className="loader-area">
            <Loader width={40} height={40} className="loader-spinner" />
          </div>
        )}
      </SectionWrap3>

      <SectionWrap4 ref={(el) => (sectionRef.current[3] = el)} id="section4" className="section">
        <div className="top container">
          <h2 className="section_title">파트너</h2>
          <span className="section_info">
            데이터유니버스와 함께하는{isMobile ? <br /> : ' '}든든한 파트너입니다.
          </span>
        </div>
        <RollingPartner />
      </SectionWrap4>

      <SectionWrap5 ref={(el) => (sectionRef.current[4] = el)} id="section5" className="section">
        <div className="container">
          <h2 className="section_title">CI</h2>
          <hr />
          <div className="item_wrap">
            <h3 className="sub_title">Symbol</h3>
            <div className="right_wrap">
              <div className="center_img_box">
                <img src={symbol} alt="" />
              </div>
              <p className="ci item_desc">
                데이터유니버스의 심볼은 데이터 분석 과정을 이미지로 형상화 한 것입니다. 수 많은
                ‘데이터’를 기반으로 더 나은 ‘유니버스’를 만들고자 하는 우리의 목표를 담았습니다.
              </p>
            </div>
          </div>
          <div className="color item_wrap">
            <h3 className="sub_title">Color</h3>
            <div className="right_wrap">
              <div className="center_img_box">
                <img src={ci} alt="" />
              </div>
              <p className="color item_desc">
                기본으로 DU Red 및 지정된 검정색과 회색을 사용하며, 밝은 배경에서 사용할 것을
                권장합니다. <br />
                브랜드 고유 이미지를 나타내기 위해 색상, 형태 변형을 금합니다.
              </p>
              <MainButton3 className="ci_btn" onClick={ciDownload}>
                데이터유니버스 CI 다운로드
              </MainButton3>
            </div>
          </div>
        </div>
      </SectionWrap5>
      <SectionWrap6 ref={(el) => (sectionRef.current[5] = el)} className="section" id="section6">
        <div className="container contact_section">
          <div className="">
            <h3 className="">
              서울특별시 영등포구
              <br />
              여의대로 70 <br />
              원센티널 10층
            </h3>
            <span className="sub_info">여의도역 3번출구 도보 3분</span>
            {/*<div className="tel_wrap">
              <a className="tel_number" href="tel:02-6013-0625">
                Tel : 02-6013-0625
              </a>
              <span className="fax_number">Fax : 02-6105-6396</span>
            </div>*/}
            <div className="contact_wrap">
              <span>고객문의 : contact@datau.co.kr</span>
              <span>제휴문의 : biz@datau.co.kr</span>
            </div>
          </div>
          <MapComponent />
        </div>
      </SectionWrap6>
      <TopButton scroll={swiperRef} />
    </>
  )
}
export default Information

const SwiperWrap = styled.div`
  min-height: 100vh;
  height: auto;

  .swiper-wrapper {
    height: 100vh;

    .swiper-slide {
      margin-bottom: 0 !important;
    }
  }

  @media screen and (max-width: 1919px) {
    //.swiper-wrapper {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
  }
  @media screen and (max-width: 1199px) {
    //.swiper-wrapper {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
  }

  @media screen and (max-width: 883px) {
    //.swiper-wrapper {
    //  height: calc(var(--vh, 1vh) * 100);
    //}
  }
`

const BannerWrap = styled.div`
  padding-top: 100px;
  display: flex;
  justify-content: center;
  height: calc(100vh - 100px);

  .banner_wrap {
    //position: relative;
    //padding: 130px 0 0;
    top: 50%;
    transform: translate(0, -50%);
    position: absolute;

    .video_wrap {
      display: flex;
      justify-content: center;

      .video {
        //width: 1400px;
        clip-path: inset(1px 1px);
      }

      .video:focus {
        outline: none;
      }

      .lottie_service {
        width: 1600px !important;
        position: absolute;
      }
    }
  }

  .arrow_area {
    width: 100%;
    align-items: center;
    text-align: center;
    display: flex;
    flex-direction: column;
    position: absolute;
    bottom: 70px;

    .arrow_text {
      font-weight: 400;
      font-size: 18px;
      line-height: 30px;
      color: ${STYLE_GUIDE.COLOR.black3};
    }

    .lottie_arrow {
      width: 26px;
      padding: 8px 0 0;
      cursor: pointer;
    }
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .banner_wrap {
      //padding: 34px 0 0;

      .video_wrap {
        .video {
          width: 1000px;
        }

        .lottie_service {
          width: 1000px !important;
          position: absolute;
        }
      }

      .arrow_area {
        padding: 41px 0 0;
        bottom: 50px;
      }
    }
  }
  @media screen and (max-width: 1199px) and (min-width: 884px) {
    height: calc(100vh - 70px);
    padding-top: 70px;
    .banner_wrap {
      //padding: 84px 0 0;
      text-align: center;

      .video_wrap {
        .video {
          width: 560px;
        }

        .lottie_service {
          width: 560px !important;
        }
      }
    }

    .arrow_area {
      bottom: 50px;

      .arrow_text {
        font-size: 16px;
      }

      .lottie_arrow {
        padding: 4px 0 0;
        width: 30px;
      }
    }
  }
  @media screen and (max-width: 883px) {
    height: calc(100vh - 70px);
    padding-top: 70px;
    .banner_wrap {
      top: 40%;
      transform: translate(0, -50%);
      //padding: 70px 0 0;

      .video_wrap {
        .video {
          width: 290px;
        }

        .lottie_service {
          width: 290px !important;
        }
      }
    }

    .arrow_area {
      bottom: 120px;

      .arrow_text {
        font-size: 16px;
      }

      .lottie_arrow {
        padding: 4px 0 0;
        width: 30px;
      }
    }
  }
`

// export const SloganWrap = styled.div`
//   text-align: left;
//   position: relative;
//   height: 100vh;
//   .video {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
//   .video_cation_area {
//     position: absolute;
//     //display: flex;
//     top: 0;
//     justify-content: space-between;
//     padding: 340px 0 0;

//     .caption {
//       opacity: 0;
//     }
//     .video_cation1 {
//       //width: 736px;
//       font-weight: 700;
//       font-size: 36px;
//       line-height: 48px;
//     }
//     .video_cation2,.video_cation3 {
//       font-weight: 400;
//       font-size:32px;
//       line-height: 44px;
//     }
//     .video_cation2 {
//       padding: 32px 0 0;
//       //width: 385px;
//     }
//     .video_cation3 {
//       //padding: 50px 0 0;
//       //width: 485px;
//     }
//   }
//   @media screen and (max-width: 1919px) and (min-width: 1200px) {
//     .video_cation_area {
//       padding: 200px 0 0;
//       .video_cation1,.video_cation2,.video_cation3 {
//         //width: 480px;
//       }
//     }
//   }

//   @media screen and (max-width: 1199px) and (min-width: 884px) {
//     .video_cation_area {
//       padding: 210px 0 0;
//       .video_cation1,.video_cation2,.video_cation3{
//         //width: 320px;
//       }
//       .video_cation1 {
//         font-weight: 700;
//         font-size: 22px;
//         line-height: 34px;
//       }
//       .video_cation2,.video_cation3 {
//         font-weight: 400;
//         font-size: 18px;
//         line-height: 30px;
//       }
//       .video_cation2{
//         padding: 20px 0 0;
//       }
//       .video_cation3 {
//         //padding: 20px 0 0;
//       }
//     }
//   }

//   @media screen and (max-width: 883px) {
//     .video_cation_area {
//       display: block;
//       padding: 150px 0 0;
//       .video_cation1,.video_cation2,.video_cation3{
//         width: 320px;
//       }
//       .video_cation1 {
//         //padding: 0 0 54px;
//         font-weight: 700;
//         font-size: 22px;
//         line-height: 34px;
//       }
//       .video_cation2,.video_cation3 {
//         font-weight: 400;
//         font-size: 18px;
//         line-height: 30px;
//       }
//       .video_cation2 {
//         padding: 20px 0 0;
//       }
//     }
//   }
// `

const SectionWrap1 = styled.div`
  padding: 152px 0 0 0;

  .version_item {
    display: flex;
    justify-content: space-between;
  }

  .version_item:not(:last-child) {
    padding: 0 0 160px 0;
  }

  .version_area {
    position: sticky;
    align-self: flex-start;
    top: 150px;
    padding: 0 134px 0 0;
  }

  .version {
    width: 139px;
    font-family: 'Roboto Variable', sans-serif;
    font-weight: 800;
    font-size: 46px;
    line-height: 52px;
    color: ${STYLE_GUIDE.COLOR.black1};
  }

  .version_img {
    > img {
      border-radius: 40px;
    }
  }

  .version_title {
    font-weight: 700;
    font-size: 32px;
    line-height: 44px;
    color: ${STYLE_GUIDE.COLOR.black1};
    padding: 40px 0 20px 0;
  }

  .version_detail {
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
  }

  .icon_area {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 30px 0 0 0;
    row-gap: 40px;

    .icon_wrap {
      display: flex;
      align-items: center;
    }
  }

  .icon_title {
    font-weight: 700;
    font-size: 20px;
    line-height: 32px;
    white-space: nowrap;
    color: ${STYLE_GUIDE.COLOR.black3};
    padding: 0 40px 0 10px;

    &.sub {
      color: ${STYLE_GUIDE.COLOR.black4};
    }
  }

  .unique {
    padding: 30px 0 0 0;
    font-weight: 700;
    font-size: 22px;
    line-height: 34px;
    color: ${STYLE_GUIDE.COLOR.black1};
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    //padding: 200px 0 0 0;
    .version_content {
      width: 742px;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    padding: 100px 0 0 0;

    .version_item {
      display: block;
    }

    .version_item:not(:last-child) {
      padding: 0 0 100px 0;
    }

    .version_area {
      position: inherit;
    }

    .version {
      font-size: 30px;
      line-height: 38px;
    }

    .version_content {
      padding: 20px 0 0 0;
    }

    .version_img {
      > img {
        border-radius: 30px;
      }
    }

    .version_title {
      font-size: 22px;
      line-height: 34px;
      padding: 30px 0 10px;
    }

    .version_detail {
      font-size: 20px;
      line-height: 32px;
    }

    .icon_area {
      padding: 40px 0 0 0;
      row-gap: 42px;
    }

    .icon_title {
      padding: 0px 42px 0px 10px;
      font-size: 18px;
      line-height: 30px;
    }
  }

  @media screen and (max-width: 883px) {
    padding: 100px 0 0 0;
    .version_item {
      display: block;
    }

    .version_item:not(:last-child) {
      padding: 0 0 100px;
    }

    .version {
      font-size: 30px;
      line-height: 38px;
    }

    .version_area {
      position: inherit;
    }

    .version_img {
      padding: 20px 0 0 0;
    }

    .version_title {
      font-size: 22px;
      line-height: 34px;
      padding: 30px 0px 10px;
    }

    .version_detail {
      font-size: 20px;
      line-height: 32px;
    }

    .unique {
      font-size: 18px;
      line-height: 30px;
    }

    .icon_area {
      // display: grid;
      // grid-template-columns: 1fr 1fr;
      display: flex;
      /* flex-wrap:wrap; */
      align-items: start;
      row-gap: 20px;

      .icon_wrap:first-child {
        float: left;
        padding: 0 20px 0 0;
      }

      .icon_title {
        font-size: 18px;
        line-height: 30px;
        padding: 0px 0px 0px 10px;
      }
    }
  }
`
export const SectionWrap2 = styled.div`
  &.patent_cert_section {
    padding: 250px 0 0 0;
  }

  .section_title {
    padding: 0 0 30px 0;
    font-weight: 700;
    font-size: 56px;
    line-height: 72px;
    color: ${STYLE_GUIDE.COLOR.black1};
  }

  .item_wrap {
    display: flex;
    justify-content: space-between;
    padding: 50px 0;

    .sub_title {
      // padding: 0 40px 0 0;
      width: 233px;
      font-weight: 700;
      font-size: 32px;
      line-height: 44px;
      color: ${STYLE_GUIDE.COLOR.black1};
    }

    .patent_list_wrap {
      .patent_list {
        font-weight: 400;
        font-size: 24px;
        line-height: 36px;
        color: ${STYLE_GUIDE.COLOR.black1};
        width: 1327px;
        padding: 0 0 40px 0;

        > li {
          display: flex;
          justify-content: space-between;
        }

        > li:not(:last-child) {
          padding: 0 0 20px;
        }

        .patent_title {
          max-width: 1185px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .patent_title:hover {
          cursor: pointer;
        }

        .patent_reg_dt {
          font-weight: 400;
          font-size: 24px;
          line-height: 26px;
          text-align: right;
          color: #999999;
          float: right;
        }
      }

      .pagination {
        padding: 40px 0 0;
      }
    }

    .main_img {
      img {
        border-radius: 30px;
      }
    }

    .sub_img {
      display: flex;
      justify-content: space-between;
      padding: 40px 0 0 0;

      img {
        cursor: pointer;
        //border: 1px solid #dbdbdb;
      }
    }
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    &.patent_cert_section {
      padding: 200px 0 0 0;
    }

    .item_wrap {
      .patent_list_wrap {
        width: 742px;

        .patent_list {
          width: 100%;
          padding: 0 0 40px 0;

          .patent_title {
            max-width: 615px;
          }
        }
      }

      .main_img,
      .sub_img {
        img {
          //border-radius: 20px;
        }
      }

      .sub_img {
        padding: 30px 0 0 0;

        img {
          width: 234px;
        }
      }
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    &.patent_cert_section {
      padding: 140px 0 0 0;
    }

    .section_title {
      font-size: 36px;
      line-height: 48px;
      padding: 0px 0px 16px;
    }

    .item_wrap {
      display: block;
      padding: 30px 0 70px;

      .sub_title {
        font-size: 28px;
        line-height: 40px;
        padding: 0 0 20px 0;
      }

      .patent_list_wrap {
        .patent_list {
          width: 100%;
          font-size: 16px;
          line-height: 30px;
          padding: 0 0 30px 0;

          > li:not(:last-child) {
            padding: 0 0 14px 0;
          }

          > li {
            display: block;
          }

          .patent_title {
            display: block;
            max-width: 745px;
          }

          .patent_reg_dt {
            float: none;
            display: block;
            text-align: left;
            font-size: 16px;
            line-height: 22px;
          }
        }
      }

      .top.patent_list_wrap {
        display: block;
      }

      .patent_list_wrap {
        display: flex;
        justify-content: space-between;
      }

      .main_img {
        img {
          //border-radius: 30px;
        }
      }

      .sub_img {
        flex-direction: column;
        padding: 0;
      }
    }
  }

  @media screen and (max-width: 883px) {
    &.patent_cert_section {
      padding: 140px 0 0 0;
    }

    .section_title {
      font-size: 36px;
      line-height: 48px;
      padding: 0 0 16px;
    }

    .item_wrap {
      padding: 30px 0 70px 0;
      display: block;

      .sub_title {
        font-size: 28px;
        line-height: 40px;
      }

      .patent_list_wrap {
        padding: 20px 0 0;

        .patent_list {
          width: 100%;
          padding: 0 0 30px;

          > li:not(:last-child) {
            padding: 0px 0px 14px;
          }

          > li {
            display: block;
            align-items: center;
          }

          .patent_title {
            display: block;
            font-size: 16px;
            line-height: 30px;
            max-width: 310px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .patent_reg_dt {
            float: none;
            font-size: 16px;
            line-height: 22px;
            display: block;
            text-align: left;
          }
        }
      }

      img {
        //border-radius: 30px;
      }

      .sub_img {
        display: block;
        padding: 30px 0 0;

        figure:first-child {
          padding: 0 0 20px;
        }
      }
    }
  }
`
export const SectionWrap3 = styled.div`
  padding: 100px 0 0 0;
  color: ${STYLE_GUIDE.COLOR.black1};

  .section_title {
    padding: 0 0 30px 0;
    font-weight: 700;
    font-size: 56px;
    line-height: 72px;
  }

  .history_item {
    display: flex;
    justify-content: space-between;
    padding: 50px 0;

    li {
      display: flex;
      padding: 0 0 31px 0;

      > img {
        margin-top: -10px;
      }
    }

    .history_content.w_history_content {
      width: 1327px;
    }

    .history_area {
      position: sticky;
      align-self: flex-start;
      top: 150px;
    }

    .year {
      font-family: 'Roboto Variable', serif;
      font-weight: 800;
      font-size: 46px;
      line-height: 52px;
    }

    .month {
      padding: 0 13px 0 0;
      font-weight: 500;
      font-size: 28px;
      line-height: 38px;
    }

    .history_detail {
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;
    }

    img {
      border-radius: 40px;
    }
  }

  .more-area {
    display: flex;
    justify-content: center;
  }

  .loader-area {
    text-align: center;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .history_item {
      padding: 50px 0 30px 0;

      li {
        > img {
          margin-top: -14px;
        }
      }

      .history_content {
        width: 742px !important;

        .card {
          width: 382px;
        }
      }

      .large_month {
        width: 135px;
      }
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    padding: 70px 0 0 0;

    .section_title {
      font-size: 36px;
      line-height: 48px;
      padding: 0 0 16px;
    }

    .history_item {
      display: block;
      padding: 30px 0 10px 0;

      li {
        > img {
          margin-top: -17px;
        }
      }

      .history_area {
        padding: 0 0 20px 0;
        position: inherit;
      }

      .history_content.w_history_content {
        width: 100%;
      }

      .year {
        font-size: 30px;
        line-height: 38px;
      }

      .month {
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
      }

      .large_month {
        width: 110px;
      }

      .history_detail {
        font-size: 18px;
        line-height: 30px;
      }

      img {
        border-radius: 30px;
      }
    }
  }

  @media screen and (max-width: 883px) {
    padding: 70px 0 0 0;

    .section_title {
      font-size: 36px;
      line-height: 48px;
      padding: 0 0 16px;
    }

    .history_item {
      padding: 30px 0 0 0;
      display: block;

      .history_area {
        position: relative;
        top: 0;
      }

      .year {
        font-size: 30px;
        line-height: 38px;
        padding: 0 0 20px;
      }

      .month {
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        padding: 0 10px 0 0;
      }

      .history_detail {
        font-size: 18px;
        line-height: 30px;
      }

      .history_content {
        width: auto !important;

        .middle {
          padding: 0 0 14px;
        }
      }

      .large_detail {
        width: 246px;
      }

      img {
        border-radius: 30px;
      }
    }
  }
`
export const SectionWrap4 = styled.div`
  padding: 170px 0 250px;
  color: ${STYLE_GUIDE.COLOR.black1};

  .top {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .section_title {
    font-weight: 700;
    font-size: 56px;
    line-height: 72px;
  }

  .section_info {
    padding: 20px 0 130px 0;
    font-weight: 400;
    font-size: 24px;
    line-height: 36px;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    padding: 140px 0 150px;
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    padding: 100px 0 145px;

    .section_title {
      font-size: 36px;
      line-height: 48px;
    }

    .section_info {
      font-size: 16px;
      line-height: 30px;
      padding: 10px 0px 50px;
      text-align: center;
    }
  }

  @media screen and (max-width: 883px) {
    padding: 110px 0 140px;

    .section_title {
      font-size: 36px;
      line-height: 48px;
    }

    .section_info {
      padding: 10px 0 50px;
      font-size: 16px;
      line-height: 30px;
      text-align: center;
    }
  }
`
export const SectionWrap5 = styled.div`
  background: ${STYLE_GUIDE.COLOR.gray5};
  color: ${STYLE_GUIDE.COLOR.black1};

  .section_title {
    padding: 100px 0 30px 0;
    font-weight: 700;
    font-size: 56px;
    line-height: 72px;
  }

  .item_wrap {
    padding: 50px 0 20px 0;
    display: flex;
    justify-content: space-between;

    .right_wrap {
      width: 1326px;
    }

    .sub_title {
      font-weight: 700;
      font-size: 32px;
      line-height: 44px;
      color: ${STYLE_GUIDE.COLOR.black1};
    }

    .item_desc {
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;
      padding: 30px 0 0 0;
    }

    .color.item_desc {
      padding: 30px 0 20px 0;
    }

    .center_img_box {
      height: 360px;
      background: #fff;
      box-shadow: 0px 8px 30px rgba(0, 0, 0, 0.03);
      border-radius: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
    }
  }

  .color.item_wrap {
    padding: 50px 0 150px 0;
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .item_wrap {
      padding: 50px 0 0 0;

      .right_wrap {
        width: 736px;
      }

      .sub_title {
        padding: 0 17px 0 0;
        width: 226px;
      }

      .center_img_box {
        height: 220px;
        width: 736px;

        img {
          width: 320px;
        }

        .item_desc {
          width: 736px;
        }
      }
    }

    .color.item_wrap {
      padding: 30px 0 120px;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    .section_title {
      padding: 60px 0px 16px;
      font-size: 46px;
      line-height: 52px;
    }

    .item_wrap {
      padding: 30px 0 0 0;
      display: block;

      .right_wrap {
        width: 100%;
        padding: 20px 0 0 0;
      }

      .center_img_box {
        width: 764px;
        height: 250px;

        img {
          width: 320px;
        }
      }

      .item_desc {
        width: 764px;
        padding: 20px 0 0 0;
        font-size: 18px;
        line-height: 30px;
      }

      .ci_btn {
        font-size: 14px;
        line-height: 24px;
        padding: 6px 16px 8px;
      }
    }

    .color.item_wrap {
      padding: 30px 0 60px 0;
    }
  }

  @media screen and (max-width: 883px) {
    .section_title {
      font-weight: 800;
      font-size: 46px;
      line-height: 52px;
      padding: 60px 0 16px;
    }

    .item_wrap {
      display: block;
      padding: 30px 0 0 0;

      .sub_title {
        font-weight: 800;
        font-size: 30px;
        line-height: 38px;
        padding: 0 0 20px 0;
      }

      .right_wrap {
        width: auto;
      }

      .center_img_box {
        height: 250px;

        img {
          width: 260px;
        }
      }

      .item_desc {
        font-size: 18px;
        line-height: 30px;
        padding: 20px 0 0 0;
      }

      .ci_btc {
        font-size: 14px;
        line-height: 24px;
        padding: 6px 16px 8px;
      }
    }

    .color.item_wrap {
      padding: 30px 0 60px 0;
    }
  }
`

const SectionWrap6 = styled.div`
  color: ${STYLE_GUIDE.COLOR.black1};

  .contact_section {
    display: flex;
    padding: 150px 0 0;
    justify-content: space-between;

    h3 {
      padding: 0 0 30px 0;
      font-weight: 700;
      font-size: 46px;
      line-height: 58px;
    }

    .sub_info {
      font-weight: 700;
      font-size: 28px;
      line-height: 40px;
    }

    .tel_wrap {
      padding: 140px 0 0 0;
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;

      .tel_number {
        display: block;
      }
    }

    .contact_wrap {
      padding: 242px 0 0 0;
      font-weight: 400;
      font-size: 24px;
      line-height: 36px;

      span {
        display: block;
      }
    }
  }

  @media screen and (max-width: 1919px) and (min-width: 1200px) {
    .contact_section {
      padding: 100px 0 0;
    }
  }

  @media screen and (max-width: 1199px) and (min-width: 884px) {
    .contact_section {
      padding: 100px 0 0;

      h3 {
        font-size: 32px;
        line-height: 44px;
        padding: 0 0 20px;
      }

      .sub_info {
        font-size: 18px;
        line-height: 30px;
      }

      .tel_wrap {
        font-size: 16px;
        line-height: 30px;
        padding: 109px 0 0;
      }

      .contact_wrap {
        font-size: 16px;
        line-height: 30px;
        //padding: 10px 0 0;
        padding: 179px 0 0;
      }
    }
  }

  @media screen and (max-width: 883px) {
    .contact_section {
      display: block;
      padding: 100px 0 0;

      h3 {
        font-size: 32px;
        line-height: 44px;
        padding: 0 0 20px;
      }

      .sub_info {
        font-size: 18px;
        line-height: 30px;
      }

      .tel_wrap {
        font-size: 16px;
        line-height: 30px;
        padding: 40px 0 0;
      }

      .contact_wrap {
        font-size: 16px;
        line-height: 30px;
        padding: 10px 0 30px;
      }
    }
  }
`
